<template>
  <div>
    <!-- Mobile Breadcrumb -->
    <div
      class="tw-flex lg:tw-hidden tw-px-4 tw-py-2 tw-w-full tw-border-b-[0.5px] 
            tw-border-solid tw-border-light-gray-2"
    >
      <ThemeIndustrialServiceMenuBreadcrumb :items="props.items" />
    </div>

    <!-- Desktop Breadcrumb -->
    <div
      class="tw-hidden lg:tw-flex tw-justify-end tw-container tw-mx-auto tw-pt-11 tw-pb-0"
      :class="props.desktopPaddingClass"
    >
      <ThemeIndustrialServiceMenuBreadcrumb :items="props.items" />
    </div>
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  items: BreadCrumb[];
  desktopPaddingClass?: string;
}>();
</script>